export const LOGO = 'logo';
export const MENU = 'menu';
export const SOCIAL_MEDIA = 'social-media';
export const BUTTON = 'button';
export const IMAGE = 'image';
export const SEARCH = 'search';
export const LANGUAGE_SELECTOR = 'language-selector';
export const SHOPPING_ICON = 'shopping-icon';
export const NAVIGATION = 'navigation';
export const DIVIDER = 'divider';
export const TEXTBOX = 'textbox';



// WEBPACK FOOTER //
// ./app/header-builder/element-types.js